import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../reducers/types";
import {
  fetchDepartureCalendar,
  setCalendar,
  setStopsOption,
  setFareclassOptionFilter,
  setTravelers,
} from "../../../../actions/actions";
import {
  getDestination,
  getOrigin,
  getDestinationCategoriesLoading,
  getOriginCategoriesLoading,
  getOriginCategories,
  getDestinationCategories,
  getHasOriginAutocompleteError,
  getHasDestinationAutocompleteError,
  getStopsOption,
  getFareclassOptionFilter,
  getTravelers,
} from "../../../../reducer";
import { LocationSearch } from "./component";

const mapDispatchToProps = {
  fetchDepartureCalendar,
  setCalendar,
  setStopsOption,
  setFareclassOptionFilter,
  setTravelers,
};

const mapStateToProps = (state: IStoreState) => {
  const origin = getOrigin(state);
  const destination = getDestination(state);

  return {
    origin,
    destination,
    travelers: getTravelers(state),
    originCategories: getOriginCategories(state),
    destinationCategories: getDestinationCategories(state),
    loading:
      !!getOriginCategoriesLoading(state) ||
      !!getDestinationCategoriesLoading(state),
    hasOriginAutocompleteError: getHasOriginAutocompleteError(state),
    hasDestinationAutocompleteError: getHasDestinationAutocompleteError(state),
    stopsOption: getStopsOption(state),
    fareclassOptionsFilter: getFareclassOptionFilter(state),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type LocationSearchConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedLocationSearch = connector(LocationSearch);
